import React from "react";

import * as S from "./styles";

export const Slide2: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Amazon />
        <S.Title>
          Top
          <br /> do pop
        </S.Title>
        <S.TextEye>
          Pabllo Vittar, Gloria Groove e Luísa Sonza estão entre os nomes mais
          fortes da música pop no Brasil. Aqui, elas se multiplicam em imagens
          que aludem à pop art e falam sobre as referências que as levaram ao
          topo das paradas.
        </S.TextEye>
        <S.Credit>Por Bárbara Rossi</S.Credit>
        <S.Text>
          <p>
            Foi-se o tempo em que precisávamos olhar para fora do Brasil para
            apreciar o melhor da música pop. O cenário do gênero em território
            nacional está cada vez mais quente e nós temos a quem agradecer.
            Pabllo Vittar, Luísa Sonza e Gloria Groove são, atualmente, as três
            divas que estão no topo musical com hits que fazem a gente dançar
            ainda que em tempos sombrios. Com uma mistura de ritmos e estilos,
            abraçando o melhor que a cultura brasileira tem a oferecer de norte
            a sul do país, nosso pop é original, múltiplo e inovador – assim
            como essas cantoras poderosíssimas que estrelam a ELLE View. Desta
            vez nos juntamos ao Amazon Music para celebrar o mês do pop na
            plataforma, dando destaque aos artistas do gênero que representam a
            cultura local com a playlist superespecial Pop Brasil.
          </p>

          <p>
            Neste ano, com Batidão tropical (2021), Pabllo fez todo mundo se
            apaixonar pelo brega do Norte e do Nordeste, com sua leitura
            futurista do ritmo que ouviu enquanto crescia. Ninguém passou impune
            por músicas como “Ama, sofre, chora” e “Triste com T”. Aliás, quão
            genial foi a popstar ao inventar um casamento e uma lua de mel
            fracassada como background desses dois clipes, respectivamente? A
            drag queen maranhense já coleciona colaborações internacionais com
            artistas como Charli XCX, Diplo e Major Lazer e tem ganhado cada vez
            mais visibilidade lá fora. Quem mais amou o remix forró de “Fun
            tonight” feito por ela para o Dawn of Chromatica (2021) de Lady
            Gaga? Como bem disse o meme, dessa vez Pabllo realmente foi longe
            demais – agora é só esperar ela dominar o mundo de vez.
          </p>

          <p>
            Luísa Sonza, por sua vez, lançou, em 2020, um dos clipes mais
            comentados do ano, “Modo turbo”, que tem no feat. a própria Pabllo e
            a Anitta. A produção, aliás, é estimada como a mais cara já
            realizada no Brasil, custando cerca de 1,5 milhão de reais. A música
            faz parte de Doce22 (2021), o álbum mais pessoal da cantora até
            então e um dos maiores sucessos musicais deste ano. Se você não
            chorou ouvindo “Penhasco” ou rebolou ao som de “VIP *-*”,
            definitivamente não viveu até agora 2021 direito. Os hits, é claro,
            estão entre os mais ouvidos do pop no Amazon Music, desbancando
            grandes nomes internacionais.
          </p>

          <p>
            Com forte influência do soul e do R&B, o último EP de Gloria Groove,
            Affair (2020), traz exatamente o que a gente ama no pop: um vozeirão
            de arrepiar, letras românticas e batidas sensuais para dançar sem
            vergonha. A drag queen, conhecida pelos clipes com narrativas
            originais e identidades visuais marcantes, entregou produções
            lindíssimas para o novo single “A tua voz”, que, por sinal, tem um
            dos vídeos mais emocionantes dos últimos tempos. Além de suas
            colaborações com gigantes da música nacional de todos os gêneros,
            Gloria imprime cada vez mais a sua história e suas origens em seu
            trabalho, marcando seu lugar como uma das principais figuras do pop
            brasileiro.
          </p>

          <p>
            Nas imagens a seguir, as três divas se multiplicam como as
            tendências que ditam e as pessoas que inspiram. Suas imagens se
            repetem tanto quanto seus hits em nossas playlists (e em nossa
            cabeça). Elas revelam todos os seus lados para se mostrarem únicas –
            mesmo em movimentos tão plurais como a música pop e a cultura
            brasileira.
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};
